// Copy link
$(document).ready(function(){

    $('.copy-link').on('click', function(e){
        e.preventDefault()
        var url = $(this).data('link')
    
        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val(url).select();
        document.execCommand("copy");
        $temp.remove();
        $('.copied').fadeIn()
    
        setTimeout(function(){
            $('.copied').fadeOut()
        }, 1000)
    })
})